import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TuneValueForm from './TuneValueForm'
import TuneValueComplete from './TuneValueComplete'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import { intializeState, runValuationComplete } from 'src/actions/valuation'
import {
  selectRequestedValuationSuccess,
  selectRequestedValuationFailure,
  selectRequestedValuationAmount,
  selectRequestedValuationUpdated,
  selectRequestedValuationError,
  selectHomeRefreshRequired,
  selectHomeFactsProgress
} from 'src/store/selectors/valuation'
import { TuneNavigateBack } from 'src/constants/trackingEvents'
import HomeFacts from 'src/Components/homeowners/Valuation/HomeFacts/HomeFacts'
import { If, Unless } from 'src/Components'
import { dispatchEvent } from 'src/helpers/tagManager'

const PanelManager = ({ history }) => {
  const dispatch = useDispatch()

  const progress = useSelector(selectHomeFactsProgress)

  const amount = useSelector(selectRequestedValuationAmount)
  const updated = useSelector(selectRequestedValuationUpdated)
  const success = useSelector(selectRequestedValuationSuccess)
  const failure = useSelector(selectRequestedValuationFailure)
  const error = useSelector(selectRequestedValuationError)
  const busy = useSelector(selectHomeRefreshRequired)

  useEffect(() => {
    dispatch(intializeState())
    return () => {
      dispatch(runValuationComplete())
      dispatch(intializeState())
    }
  }, [dispatch])

  useEffect(() => {
    if (progress === 100) {
      dispatch(runValuationComplete())
    }
  }, [progress, dispatch])

  const handleClickBack = () => {
    dispatchEvent(TuneNavigateBack, {
      eventLabel: 'Last: Finished'
    })

    history.push(OVERLAY_HELPERS.tuneYourValue.getOrigin())
  }

  return (
    <>
      <Unless condition={progress}>
        <TuneValueForm />
      </Unless>
      <If condition={progress}>
        <Unless condition={progress === 100}>
          <HomeFacts />
        </Unless>
        <If condition={progress === 100}>
          <TuneValueComplete
            amount={amount}
            updated={updated || busy}
            success={success}
            failure={failure}
            busy={busy}
            error={error}
            onClickBack={handleClickBack}
          />
        </If>
      </If>
    </>
  )
}

export default PanelManager
